import React from 'react';
import { A4_PAGE_HEIGHT, A4_PAGE_WIDTH } from '@/constants';
import { cn } from '@/lib/utils';
import { CoverPage } from './CoverPage';
import type { ComponentProps } from 'react';

type CoverThumbnailProps = ComponentProps<typeof CoverPage> & {
    /** Rendered width in px; the live A4 render is scaled down to fit. */
    width: number;
};

export const CoverThumbnail: React.FC<CoverThumbnailProps> = ({
    width,
    className,
    ...coverPageProps
}) => {
    const scale = width / A4_PAGE_WIDTH;

    return (
        <div
            aria-hidden
            className={cn('pointer-events-none select-none overflow-hidden', className)}
            style={{ width, height: A4_PAGE_HEIGHT * scale }}
        >
            <div style={{ transform: `scale(${scale})`, transformOrigin: 'top left' }}>
                <CoverPage {...coverPageProps} />
            </div>
        </div>
    );
};
